import React from "react";
import { useDataMan } from "../../hooks/useDataMan";
import { useDataManCell } from "../../hooks/useDataManCell";
import { useDataManColumn } from "../../hooks/useDataManColumn";
import { DataManCollapsibleButton } from "./DataManCollapsibleButton";

export interface DataManCellContentProps {
  hasCollapseControl?: boolean;
}

export const DataManCellContent: React.FC<DataManCellContentProps> = ({
  hasCollapseControl
}) => {
  const { value } = useDataManCell();
  const { column, isActionColumn, isSortableHandler, isSelectionColumn } =
    useDataManColumn();
  const { visibleColumns, hasBulkSelection } = useDataMan();
  const RendererComponent = column?.renderer;

  // When a selection checkbox precedes the columns, the first data column drops
  // its left padding so it sits flush against the checkbox cell (no extra gap).
  const dropLeftPad =
    hasBulkSelection && !!column && visibleColumns?.[0]?.key === column.key;

  // Different styling for different column types
  const contentWrapperClass = isSortableHandler
    ? "flex items-center justify-center pl-4 pr-2 py-4 cursor-grab"
    : isActionColumn
      ? "flex items-center justify-end pr-2 py-2 whitespace-nowrap"
      : isSelectionColumn
        ? "flex items-center justify-start pl-4 py-4"
        : column?.disableContentPadding
          ? "flex min-w-0 items-center"
          : dropLeftPad
            ? "flex min-w-0 pr-4 items-center"
            : "flex min-w-0 px-4 items-center";

  return (
    <div className={contentWrapperClass}>
      {hasCollapseControl && <DataManCollapsibleButton />}
      {RendererComponent ? (
        <div
          className={
            isActionColumn || isSortableHandler ? "" : "min-w-0 flex-1"
          }
        >
          <RendererComponent />
        </div>
      ) : (
        <div
          className={
            isActionColumn || isSortableHandler ? "" : "min-w-0 flex-1 truncate"
          }
        >
          {typeof value === "string" || typeof value === "number"
            ? value
            : React.isValidElement(value)
              ? value
              : null}
        </div>
      )}
    </div>
  );
};
